import { Component, Input } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IHeroBannerV2TileInstance } from '../../../../interfaces/tiles/definitions/hero-banner-v2-tile-definition.interface';
import {
  resolveSiteAssetCssValue,
  resolveSiteAssetUrl,
} from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-bi-hero-banner-v2-tile',
  templateUrl: './hero-banner-v2-tile.component.html',
  styleUrls: ['./hero-banner-v2-tile.component.scss'],
})
export class HeroBannerV2TileComponent {
  @Input() tileInstance: IHeroBannerV2TileInstance;

  private get siteBaseUrl(): string {
    return this.tenantService.currentTenantData?.primaryWebUrl ?? '';
  }

  public get contentImgPath(): string {
    return resolveSiteAssetUrl(this.tileInstance?.contentImg ?? '', this.siteBaseUrl);
  }

  public get backgroundStyle(): string {
    return resolveSiteAssetCssValue(this.tileInstance?.background ?? '', this.siteBaseUrl);
  }

  constructor(private readonly tenantService: CurrentTenantService) {}

  scrollToElement(element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }
}
